// extracted by mini-css-extract-plugin
export var cartIcon = "cart-widget-module--cart-icon--PNfMz";
export var cartWidget = "cart-widget-module--cart-widget--T5G3u";